/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Store } from '@ngrx/store';
import { ImportScheduleState } from './import-schedule-reducer';
import { BrowseClick, ChangeDialogHeight, ImportScheduleClick } from './import-schedule-actions';
import { selectFileName } from './import-schedule-selector';
import { IImportScheduleFacade } from '../../../../../data-access/src/lib/domain/facades-models/import-schedule-facade';
import { Injectable } from '@angular/core';
import { ReceiveMessageHandler } from '@mep/web-browser-bridge';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { ImportScheduleReceiveController } from '../../receive-controllers/import-schedule-receive-controller';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportScheduleFacade implements IImportScheduleFacade {
  constructor(
    private store: Store<ImportScheduleState>,
    private readonly receiveMessageService: ReceiveMessageHandler,
    localStorage: LocalStorageService
  ) {
    this.receiveMessageService.registerController(new ImportScheduleReceiveController(localStorage));
  }

  importSchedule(scheduleName: string): void {
    localStorage.setItem('applyScheduleResult', '');
    this.store.dispatch(ImportScheduleClick({ scheduleName: scheduleName }));
  }

  windowResize(height: number): void {
    this.store.dispatch(ChangeDialogHeight({ height: height }));
  }

  browseImportSchedule(): Observable<string> {
    this.store.dispatch(BrowseClick());
    return this.store.select(selectFileName);
  }
}
